var map = {
	"./Liker.address.js": 1147,
	"./NiftyInk.address.js": 1148,
	"./NiftyMain.address.js": 1149,
	"./NiftyMediator.address.js": 1150,
	"./NiftyRegistry.address.js": 1151,
	"./NiftyToken.address.js": 1152
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 642;